import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles((theme) => ({
  inputField: {
    margin: theme.spacing(2, 1),
    flex: 1,
  },
}));

export default (props) => {
  const classes = useStyles();

  let handleDropdownChange = (event) => {
    props.handleChange({target: {value: event.target.value, name: props.name}});
  }

  return (
    <div style={{margin: "-5px 20px"}}>
      <div style={{
        color: "rgba(0, 0, 0, 0.54)",
        padding: 0,
        margin: "10px 5px -14px 5px",
        fontSize: "0.8rem",
        fontFamily: '"Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        fontWeight: 400,
        lineHeight: 1
      }}>{props.title}</div>
      <Select
        value={props.listDetails[props.name] || "WordList"}
        onChange={handleDropdownChange}
        className={classes.inputField}
        disabled={!props.isNewList}
      >
        <MenuItem value="WordList">WordList</MenuItem>
        <MenuItem value="WordsAndPictures">WordsAndPictures</MenuItem>
        {!props.isNewList &&
          <MenuItem value="WordsWithPictures">WordsWithPictures</MenuItem>
        }
        {!props.isNewList &&
          <MenuItem value="WordsDescAndPictures">WordsDescAndPictures</MenuItem>
        }
      </Select>
    </div>
  );
}
